<template>
		<div class="tabWrapper salaryHistory">
			<no-info v-if="!isShowContent" text="The user does not have information yet paid month"/>
			<div v-else class="main">
				<!-- Кастомные кнопки навигации -->
				<div class="custom-navigation">

					<button class="previous" @click="goPrev">
						<svg-sprite icon-id="previous"></svg-sprite>
					</button>
					<button class="next" @click="goNext" v-show="activeIndex > 0">
						<svg-sprite icon-id="next"></svg-sprite>
					</button>
				</div>

				<swiper
						v-if="rowsList"
						ref="mySwiper"
						:space-between="10"

						:pagination="false"
						:navigation="false"
						dir="rtl"
						:breakpoints="{
			      640: { slidesPerView: 1, },
			      768: { slidesPerView: 2, },
			      1024: { slidesPerView: 2, },
			    }"
						@swiper="onSwiper"
						@slideChange="onSlideChange"

				>
					<swiper-slide
							v-for="(item, index) in rowsList"
							:key="index"
							:item="item"
					>
						<salary-history-slide
								:item="item"
								:months="defaultPayРistory_months"
								:is-pay="false"
								flag="accountSalaryHistorySlide"
								@updatePay="onPay"
								@updateEditItem="onEditItem"
						></salary-history-slide>
					</swiper-slide>
				</swiper>
			</div>

			<salary-pay
					v-if="isSalaryPay"
					:activeItem='salaryPayMonth'
					:id="id"
					@updateClose="onSalaryPayClose"
					@updateSave="onSendSalaryPay"
			></salary-pay>

			<dialog-remove
					v-if="isDialogRemove"
					:titleRemove="titleRemove"
					:textRemove="textRemove"
					@updateRemove="onRemove"
					@updateCloseRemove="onCloseRemove"
			></dialog-remove>
		</div>
	</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Navigation, Pagination } from 'swiper';
import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2';
// Import Swiper styles
import 'swiper/swiper-bundle.css';
import SalaryHistorySlide from "@/pages/Account/Tabs/SalaryHistorySlide/SalaryHistorySlide.vue";
import SalaryPay from "@/pages/UserProfile/Drawers/SalaryPay.vue";
import DialogRemove from "@/shared/DialogRemove/DialogRemove.vue";
import { TEXT, TITLE } from "@/pages/Settings/UserAccountSettings/constants";
import NoInfo from "@/shared/NoInfo/NoInfo.vue";
SwiperCore.use([ Navigation, Pagination ]);

export default {
	name: "AccountTabSalaryHistory",

	components: {
		NoInfo,
		DialogRemove,
		SalaryPay,
		SalaryHistorySlide,
		Swiper,
		SwiperSlide
	},
	computed: {
		...mapGetters([
			'defaultPayРistory_months',
			'defaultPayРistory_rows',
			'defaultPayРistory_first',
		]),
	},
	props: {
		user: Object,
	},
	data: () => ({
		id: null,
		months: null,
		rowsList: null,
		loadMonths: [],
		swiperRef: null,
		activeIndex: 0,
		filteredMonths: null,
		isSalaryPay: false,
		salaryPayMonth: null,

		isDialogRemove: false,
		titleRemove: null,
		textRemove: null,
		activeItem: null,
		nameComponent: null,
		isShowContent: true,

	}),
	methods: {
		...mapActions([
			'getDefaultPayРistory',
			'getDefaultPayРistoryPrev',
			'getDefaultSalaryPay',
			'deleteDefaultSalaryPayment',
			'setAlert',
		]),

		onPay(args) {
			const { item } = args;
			this.isSalaryPay = true;
			this.salaryPayMonth = item;
		},
		onSalaryPayClose() {
			this.isSalaryPay = false;
		},
		async onEditItem(args) {
			const { key, item, nameComponent } = args;

			this.nameComponent = nameComponent;
			this.activeItem = item;
			if (nameComponent === 'salaryHistorySlide' && key === 'delete1') {
				const title = TITLE.REMOVE_SALARY_PAYMENT;
				const text = TEXT.REMOVE_SALARY_PAYMENT;
				this.onRemoveDialog({ title, text });
			}
		},
		async onRemove() {
			if (this.nameComponent === 'salaryHistorySlide') {
				const { id } = this.activeItem;
				await this.deleteDefaultSalaryPayment(id);
				this.onCloseRemove();
			}
		},
		onRemoveDialog(args) {
			const { title, text } = args;
			this.titleRemove = title;
			this.textRemove = text;
			this.isDialogRemove = true;
		},
		onCloseRemove() {
			this.isDialogRemove = false;
		},

		async onSendSalaryPay(args) {
			await this.getDefaultSalaryPay(args);

			this.isSalaryPay = false;
		},

		onSwiper(swiper) {
			this.swiperRef = swiper;
		},
		onSlideChange(swiper) {
			this.activeIndex = swiper.activeIndex;
		},

		async goNext() {
			this.swiperRef.slidePrev();
		},
		async updateLastRow() {
			// Получить список месяцев из rowsList
			const rowsListMonths = new Set(this.rowsList.map(row => row.month));

			// Фильтровать месяцы из массива months
			this.filteredMonths = this.months.filter(month => !rowsListMonths.has(month.month));

			if (this.filteredMonths && this.filteredMonths.length > 0) {
				const date = this.filteredMonths[0].date;
				const id = this.id;

				const { rows } = await this.getDefaultPayРistoryPrev({ date, id });

				this.rowsList.push(Object.values(rows)[0]);

				// Обновляем Swiper, чтобы отобразить новый слайд
				this.$nextTick(() => {
					this.swiperRef.update(); // Обновляем Swiper
					this.swiperRef.slideNext(); // Переходим на предыдущий слайд
				});
			} else {
				this.swiperRef.slideNext(); // Переходим на предыдущий слайд
				await this.setAlert({ type: "info", message: "No information for previous month 🤷🗿" });

			}
		},
		goPrev() {
			if ((this.rowsList.length === 2 && this.activeIndex === 0)
					|| (this.rowsList.length === 1 && this.activeIndex === 0)
					|| (this.rowsList.length === this.activeIndex + 2 )) {
				this.updateLastRow();
			} else {
				this.swiperRef.slideNext();
			}

		},
		goToSlide(index) {
			this.swiperRef.slideTo(index);

		}
	},
	async mounted() {
		const {
			id,
		} = this.user;
		this.id = id;

		await this.getDefaultPayРistory(id);

		this.rowsList = Object.values(this.defaultPayРistory_rows);
		this.loadMonths = Object.keys(this.defaultPayРistory_rows);
		this.months = this.defaultPayРistory_months;

		this.isShowContent = this.rowsList.length > 0 ? true : false;
		this.onSwiper(); // Обновляем Swiper
	},

	watch: {
		defaultPayРistory_first(value, oldValue) {
			if (value !== oldValue) {
				// Ключ для поиска
				const key = Object.keys(value)[0];

				// Обновление данных в rowsList
				this.rowsList = this.rowsList.map(item =>
					item.date === key ? value[key] : item
				);
			}
		},
	},
};
</script>

<style lang="scss">
@import "AccountTabSalaryHistory";

</style>
